import { render, staticRenderFns } from "./OutboxLetters.vue?vue&type=template&id=4d3574bc"
import script from "./OutboxLetters.vue?vue&type=script&lang=js"
export * from "./OutboxLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports